export default __webpack_public_path__ + "static/media/white-icon-logo.7526d3ae.svg";